import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23024 29141"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M11732 28229h8500V8947c0-1318-1074-2390-2391-2390h-3718c-1319 0-2391 1072-2391 2390v19282zm8954 912h-9409c-252 0-456-204-456-456V8947c0-1820 1481-3301 3301-3301h3719c1821 0 3300 1481 3300 3301v19738c0 252-203 456-455 456z"
        className="fil0"
      />
      <path
        d="M16922 6557h-1881c-252 0-456-204-456-456V2919c0-251 204-455 455-455 252 0 456 204 456 455v2727h971V2919c0-251 205-455 455-455 252 0 456 204 456 455v3182c0 252-204 456-456 456z"
        className="fil0"
      />
      <path
        d="M15982 3734c-1030 0-1867-838-1867-1867 0-1030 837-1867 1867-1867 251 0 455 204 455 456s-204 454-455 454c-527 0-957 430-957 957 0 526 429 956 957 956 404 0 767-256 902-637 83-237 343-362 580-278 238 84 361 344 278 581-263 744-972 1245-1760 1245z"
        className="fil0"
      />
      <path
        d="M17849 1882h4264V910h-4528c167 281 264 607 264 957v15zm4719 911h-5255c-148 0-287-72-372-192-86-122-106-277-57-416 36-101 54-209 54-318 0-527-429-957-956-957-252 0-456-202-456-454s204-456 456-456h6586c252 0 456 204 456 456v1881c0 252-204 456-456 456z"
        className="fil0"
      />
      <path
        d="M22098 6087c-81 0-164-23-239-69l-4914-3024c-214-132-281-412-149-627 131-214 412-280 626-148l4915 3023c213 133 281 413 149 627-86 141-235 218-388 218zM5160 23494c-252 0-456-203-456-455v-1882c0-252 204-456 456-456 507 0 983-197 1341-555 359-359 556-835 556-1341V6572c0-1378 537-2675 1512-3649s2270-1511 3649-1511h2352c251 0 455 204 455 455 0 252-204 456-455 456h-2352c-2343 0-4250 1905-4250 4249v12233c0 749-292 1455-823 1985-421 421-953 693-1529 786v981c1870-227 3323-1823 3323-3752l1-12115c0-1873 1523-3396 3395-3396h2706c251 0 455 204 455 454 0 252-204 456-456 456h-2705c-1370 0-2485 1115-2485 2486v12115c0 1251-488 2429-1374 3316-885 885-2064 1373-3316 1373z"
        className="fil0"
      />
      <path
        d="M5160 23039zM910 20358v3481l3794-1139v-1204L910 20358zm-455 4548c-96 0-192-32-272-90-114-86-183-223-183-365v-4705c0-144 68-280 183-365 115-87 266-114 403-72l4706 1412c192 58 324 235 324 436v1882c0 201-132 378-325 436L586 24886c-43 13-88 20-131 20zM20686 10320h-9409c-252 0-456-203-456-455s204-456 456-456h9409c252 0 455 204 455 456s-203 455-455 455zM20686 26318h-9409c-252 0-456-204-456-456 0-251 204-455 456-455h9409c252 0 455 204 455 455 0 252-203 456-455 456zM20686 24435h-9409c-252 0-456-204-456-455s204-455 456-455h9409c252 0 455 204 455 455s-203 455-455 455zM20686 12202h-9409c-252 0-456-203-456-455 0-251 204-455 456-455h9409c252 0 455 204 455 455 0 252-203 455-455 455zM13719 18279c-84 250-105 418-105 526 0 1305 1062 2367 2368 2367 1304 0 2367-1062 2367-2367 0-309-172-1065-1321-2666-369-513-742-976-1007-1295-166 354-206 763-109 1161 39 157 57 321 54 485-10 484-206 940-552 1285-347 344-803 538-1289 543-136 2-273-11-406-39zm2263 3804c-1809 0-3278-1471-3278-3278 0-362 109-782 337-1285 51-112 147-201 265-241 118-42 247-33 358 24 139 72 290 108 449 105 509-7 933-428 943-937 1-84-8-168-28-249v-1c-209-845 3-1730 564-2369 34-36 50-57 50-57 87-95 210-150 340-150 129 0 252 55 338 150 30 33 730 816 1443 1807 1008 1401 1497 2448 1497 3203 0 1807-1471 3278-3278 3278z"
        className="fil0"
      />
      <path
        d="M15982 19934c-39 45-79 92-118 140-358 438-368 611-368 613 0 267 218 485 486 485 267 0 485-218 485-485 0-5-12-180-373-620-38-47-75-91-112-133zm0 2149c-770 0-1397-627-1397-1396 0-328 188-717 573-1189 252-307 500-543 510-554 176-166 451-166 627 0 10 11 259 247 510 554 385 472 573 861 573 1189 0 769-626 1396-1396 1396z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
